// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/lander.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveLanderRequest, ArchiveLanderResponse, CreateLanderRequest, CreateLanderResponse, DuplicateLanderRequest, DuplicateLanderResponse, GetLanderLibraryRequest, GetLanderLibraryResponse, GetLanderRequest, GetLanderResponse, GetLanderUsageRequest, GetLanderUsageResponse, ListLanderCampaignsRequest, ListLanderCampaignsResponse, ListLanderNumbersRequest, ListLanderNumbersResponse, ListLandersRequest, ListLandersResponse, SetLanderAnalyticsRequest, UpdateLanderRequest, UpdateLanderResponse } from "./lander_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.LanderService
 */
export const LanderService = {
  typeName: "tracker.v1.LanderService",
  methods: {
    /**
     * @generated from rpc tracker.v1.LanderService.ListLanders
     */
    listLanders: {
      name: "ListLanders",
      I: ListLandersRequest,
      O: ListLandersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.GetLander
     */
    getLander: {
      name: "GetLander",
      I: GetLanderRequest,
      O: GetLanderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.CreateLander
     */
    createLander: {
      name: "CreateLander",
      I: CreateLanderRequest,
      O: CreateLanderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.UpdateLander
     */
    updateLander: {
      name: "UpdateLander",
      I: UpdateLanderRequest,
      O: UpdateLanderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.ArchiveLander
     */
    archiveLander: {
      name: "ArchiveLander",
      I: ArchiveLanderRequest,
      O: ArchiveLanderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.DuplicateLander
     */
    duplicateLander: {
      name: "DuplicateLander",
      I: DuplicateLanderRequest,
      O: DuplicateLanderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.GetLanderUsage
     */
    getLanderUsage: {
      name: "GetLanderUsage",
      I: GetLanderUsageRequest,
      O: GetLanderUsageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.GetLanderLibrary
     */
    getLanderLibrary: {
      name: "GetLanderLibrary",
      I: GetLanderLibraryRequest,
      O: GetLanderLibraryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.ListLanderNumbers
     */
    listLanderNumbers: {
      name: "ListLanderNumbers",
      I: ListLanderNumbersRequest,
      O: ListLanderNumbersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.LanderService.ListLanderCampaigns
     */
    listLanderCampaigns: {
      name: "ListLanderCampaigns",
      I: ListLanderCampaignsRequest,
      O: ListLanderCampaignsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SetLanderAnalytics toggles the per-lander behavior-analytics opt-in — the
     * direct /lander/{id}/ serve injects the beacon when on. Workspace-write.
     *
     * @generated from rpc tracker.v1.LanderService.SetLanderAnalytics
     */
    setLanderAnalytics: {
      name: "SetLanderAnalytics",
      I: SetLanderAnalyticsRequest,
      O: GetLanderResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

